import React from 'react';
export function Testimonial() {
  return <section className="py-24 bg-cozy-bg" data-id="element-290">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-291">
        <div className="mb-8" data-id="element-292">
          <span className="text-cozy-accent font-serif text-6xl leading-none" data-id="element-293">
            "
          </span>
        </div>
        <blockquote className="font-serif text-3xl md:text-4xl leading-tight text-cozy-text mb-10" data-id="element-294">
          GetCozy completely changed how our engineering team operates. We no
          longer spend hours digging through Slack threads or outdated Notion
          docs. The AI just knows.
        </blockquote>
        <div className="flex items-center justify-center gap-4" data-id="element-295">
          <div className="w-12 h-12 rounded-full bg-cozy-accent/20 flex items-center justify-center text-cozy-accent font-medium text-lg border border-cozy-accent/30" data-id="element-296">
            JD
          </div>
          <div className="text-left" data-id="element-297">
            <div className="font-medium text-cozy-text" data-id="element-298">Jane Doe</div>
            <div className="text-sm text-cozy-muted" data-id="element-299">
              VP of Engineering, TechFlow
            </div>
          </div>
        </div>
      </div>
    </section>;
}